import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from 'src/app/services/appconfig/app-config.service';
import { catchError, map } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { AppInsightsService } from 'src/app/services/common/appinsights.service';

@Injectable({
  providedIn: 'root'
})

export class UserInfoService {

  private url: string;

  constructor(appConfigService: AppConfigService,
    private http: HttpClient, private appInsights: AppInsightsService) {
       
    this.url = appConfigService.get('apiUrl');    
  }


  // Function to fetch data from the API
  getUserAccessInfo(userId: string): Observable<any> {
    this.appInsights.logEvent("getUserAccessInfo");
    
    return this.http.get(this.url + '/Master/GetBATAllRolesModulesApproverMappings/' + userId) //
      .pipe(
        map(response => response),
        catchError(response => {
          this.appInsights.logException(response);
          return throwError(response);
        })
      );
    
  }
}